import { makeStyles } from 'tss-react/mui';

import macOsScrollBar from 'main/theme/mac-os-scrollbar';

export default makeStyles({ name: 'DataTable' })({
    shape: {
        borderRadius: 16,
        border: '1px solid #ECECEC'
    },
    container: {
        background: '#FFF',
        paddingLeft: 24,
        paddingRight: 24,
        boxSizing: 'border-box',
        position: 'relative',
        ...macOsScrollBar({ my: 4 }),
        overflowY: 'hidden',
        mask: 'linear-gradient(90deg, transparent, white 24px calc(100% - 24px), transparent)'
    },
    pagination: {
        position: 'sticky',
        left: 0,
        right: 0,
        margin: '24px 0'
    },
    table: {
        tableLayout: 'fixed'
    },
    th: {
        lineHeight: 0,
        paddingTop: 24,
        paddingBottom: 24,
        boxSizing: 'border-box'
    },
    td: {
        overflow: 'hidden',
        color: '#232323',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '150%'
    },
    sort: {
        flexDirection: 'row-reverse',
        color: '#5F5F5F !important',
        fontSize: 13,
        fontWeight: 700,
        lineHeight: 0,
        whiteSpace: 'nowrap'
    }
});
